import axios from 'axios'

export const getMedicalReadingData = (
  timeRange,
  deviceUUID,
  token
) => {
  var payload = JSON.stringify({
    eventtypes: ['device_medical_reading_event'],
  })

  var config = {
    method: 'put',
    url: `${window.envConfig.MR_DOMAIN}/hacloud/api/v1/ecs/events/${deviceUUID}/eventtypes/${timeRange}`,
    data: payload,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }

  return axios(config)
    .then(function (response) {
      return response.data
    })
}
